import { JSX, useState } from "react";
import { Button, Checkbox, Tooltip } from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./mapGl.scss";

export const MapTools = ({
  isBigMap,
  showFieldImg,
  setShowFieldImg,
}): JSX.Element => {
  const [collapse, setCollapse] = useState(true);

  return (
    <div style={{ position: "absolute", top: isBigMap ? "60px" : "40px" }}>
      <Tooltip
        title={`${collapse ? "Öppna" : "Stäng"} verktyg`}
        placement="right"
      >
        <Button
          onClick={() => setCollapse(!collapse)}
          className={`mapToolsBtnIcon ${collapse ? "rotate" : ""}`}
        >
          <FontAwesomeIcon color="black" icon={faChevronRight} size="lg" />
        </Button>
      </Tooltip>
      <div className={`map-tools ${collapse ? "collapseMapTools" : ""}`}>
        <div
          style={{
            boxSizing: "border-box",
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
          }}
        >
          <Tooltip
            title={`${showFieldImg ? "Visar" : "Döljer"} fältbilder`}
            placement="right"
            enterDelay={250}
          >
            <Checkbox
              checked={showFieldImg}
              onChange={() => setShowFieldImg(!showFieldImg)}
              checkedIcon={<PhotoCameraIcon />}
              icon={<NoPhotographyIcon color="warning" />}
            />
          </Tooltip>
        </div>
      </div>
    </div>
  );
};
